import { render, staticRenderFns } from "./ActivityCard.vue?vue&type=template&id=54d8daea&scoped=true&"
import script from "./ActivityCard.vue?vue&type=script&lang=js&"
export * from "./ActivityCard.vue?vue&type=script&lang=js&"
import style0 from "./ActivityCard.vue?vue&type=style&index=0&id=54d8daea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d8daea",
  null
  
)

export default component.exports